export default __webpack_public_path__ + "static/media/blueT.7be166cc.svg";